import Vue from 'vue'
import Router from 'vue-router'
import instructions from '@/views/instructions/index.vue'//导入组件

Vue.use(Router);

export default new Router({
    routes:[
        {
            path:'/',
            redirect:'/instructions'
        },
        {
            path:'/instructions',
            name:'instructions',
            component:instructions
        }
    ]
})
